import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { installErrorReporting } from "./lib/errorReporting";
import { AppErrorBoundary } from "./components/AppErrorBoundary";

installErrorReporting();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppErrorBoundary><App /></AppErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
);
